/* import __COLOCATED_TEMPLATE__ from './text.hbs'; */
import UserFieldBase from "./base";

export default class UserFieldText extends UserFieldBase {}
